/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
GameplayEventDispatcher = xClass("GameplayEventDispatcher", Event)
GameplayEvent = table([1, "UseMove", "GAMEPLAYEVENT.USEMOVE"], [1, "Eliminate", "GAMEPLAYEVENT.ELIMINATE"])
var instance = null
GameplayEventDispatcher.getInstance = function () {
    var self = this
    if (!instance) {
        instance = GameplayEventDispatcher.new()
    }
    return instance
}
GameplayEventDispatcher.prototype.ctor = function () {
    var self = this
    self.bind(self)
}
